module.exports = __webpack_public_path__ + "static/assets/a31258831e99191194a9f3379a2d1026.svg";